import { render, staticRenderFns } from "./ILMControl.vue?vue&type=template&id=80b16fda"
import script from "./ILMControl.vue?vue&type=script&lang=js"
export * from "./ILMControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports